import { render, staticRenderFns } from "./OrderTotalsRow.vue?vue&type=template&id=88e3ab66&scoped=true&"
import script from "./OrderTotalsRow.vue?vue&type=script&lang=js&"
export * from "./OrderTotalsRow.vue?vue&type=script&lang=js&"
import style0 from "./OrderTotalsRow.vue?vue&type=style&index=0&id=88e3ab66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e3ab66",
  null
  
)

export default component.exports